<script setup lang="ts">
import { DEROGATION_STATUS, DEROGATION_STATUS_LABELS } from '@/constants/derogationStatus'

defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <span
        :class="{
          'badge bg-blue-100': params.data.status === DEROGATION_STATUS.PENDING,
          'badge bg-emerald-100': params.data.status === DEROGATION_STATUS.APPROVED,
          'badge bg-red-100': params.data.status === DEROGATION_STATUS.REJECTED,
        }"
      >
        {{ DEROGATION_STATUS_LABELS[params.data.status as keyof typeof DEROGATION_STATUS_LABELS] || params.data.status }}
      </span>
    </div>
  </div>
</template>

<style scoped></style>
